import { FunctionComponent, useState } from 'react'
import { NewsItem } from 'Frontend/types/types'
import { CommentCollectionItem } from 'Frontend/scripts/models/communityNews.model'
import Comments from 'Features/Components/Comments/Comments'
import * as commentsService from 'Frontend/scripts/services/comments.services'
import { useScroll } from 'Frontend/hooks/useScroll'

interface NewsItemProps {
  newsItem: NewsItem
  commentCollection?: CommentCollectionItem
}

const NewsAngBlogListItem: FunctionComponent<NewsItemProps> = ({ newsItem, commentCollection }) => {
  const { scrollToElement } = useScroll()
  const [comments, setComments] = useState<CommentCollectionItem>(commentCollection as CommentCollectionItem)
  const { heading, date, description, category, url, contentLink } = newsItem

  const getComments = () => {
    commentsService.getComments(contentLink.id).then((comments) => {
      setComments(comments)
      scrollToElement(`${contentLink.id}-comments`)
    })
  }

  return (
    <article className="newslist__item position-relative">
      <h3 className="newslist__item-title">
        <a href={url} className={`newslist__item-link ${!commentCollection && 'stretched-link'}`}>
          {heading}
        </a>
      </h3>
      <div className="date">
        <span className="me-2">{date}</span> {category}
      </div>
      <p className="newslist__item-text" id={`${contentLink.id}-comments`}>
        {description}
      </p>
      {comments && (
        <Comments
          contentId={contentLink.id}
          {...comments}
          onPostAdded={() => getComments()}
          onPostDeleted={() => getComments()}
        />
      )}
    </article>
  )
}

export default NewsAngBlogListItem
